import { CalendarDays, Users, LayoutGrid, Mail, Globe, Smartphone, BarChart3, type LucideIcon } from "lucide-react";

export type FeatureDomain = {
  icon: LucideIcon;
  title: string;
  features: string[];
};

export const featureDomains: FeatureDomain[] = [
  {
    icon: CalendarDays,
    title: "Réservations et disponibilités",
    features: [
      "Réservations illimitées, créneaux ou recherche libre par tranche (15 / 30 / 60 min)",
      "Horaires d'ouverture par jour, exceptions sur dates précises",
      "Fermetures complètes par période (vacances, événement privé)",
      "Limites de capacité par créneau (réservations ou personnes)",
      "Mise en pause des réservations avec message personnalisé",
      "Plage de réservation configurable (aujourd'hui à 3 mois)",
      "Modification et annulation client par lien sécurisé",
      "Liste d'attente, walk-in, gestion des groupes",
    ],
  },
  {
    icon: LayoutGrid,
    title: "Tables, salle, plan",
    features: [
      "Tables illimitées, assignation automatique intelligente",
      "Tables combinées dynamiques pour les grands groupes",
      "Plan de salle interactif, zones (terrasse, salle, bar)",
      "Fermetures ciblées par table ou par zone",
      "Swap de table avec détection automatique des conflits",
      "4 vues du dashboard : grouped, liste, timeline, plan de salle",
    ],
  },
  {
    icon: Users,
    title: "Clients et notes",
    features: [
      "Fiche client complète : coordonnées, allergies, notes privées",
      "Historique automatique : visites, dernière venue, couverts cumulés",
      "Statuts : blacklist, no-show, invité VIP",
      "Tags personnalisés (allergies, anniversaire, VIP, business)",
      "Consentements marketing tracés (email, SMS, avis)",
      "Import CSV au démarrage, export CSV à tout moment",
    ],
  },
  {
    icon: Mail,
    title: "Communications automatiques",
    features: [
      "Confirmation de réservation par email (SMS optionnel)",
      "Rappel J-1 pour réduire les no-shows",
      "Suivi 4h après la réservation (avis Google, TripAdvisor)",
      "Résumé quotidien à 7h avec les réservations du jour",
      "Templates modifiables par restaurant",
      "Lien de désabonnement conforme RGPD",
    ],
  },
  {
    icon: Globe,
    title: "Widget et site internet",
    features: [
      "Widget de réservation embeddable en une ligne de code",
      "Responsive : s'adapte automatiquement mobile et desktop",
      "Page publique dédiée : piktable.ch/ton-resto",
      "Consentement cookies intégré au widget",
      "Mode sombre automatique selon préférences du visiteur",
    ],
  },
  {
    icon: Smartphone,
    title: "Équipe et mobilité",
    features: [
      "Comptes staff multiples, rôles admin et staff séparés",
      "Application mobile (PWA) installable sur iPhone et Android",
      "Notes staff privées sur chaque réservation",
      "Impression de la liste des réservations du jour",
    ],
  },
  {
    icon: BarChart3,
    title: "Statistiques et reporting",
    features: [
      "KPIs jour / semaine / mois / année (réservations, no-shows, taux d'arrivée)",
      "Évolution 12 mois glissants, comparaisons de périodes",
      "Corrélation météo : prévisions et impact sur la fréquentation",
      "Stats enfants, terrasse, large groups",
      "Export CSV brut pour Excel",
    ],
  },
];
